import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalClose, ModalDialog, Stack, Typography } from '@mui/joy';
import { QRCodeSVG } from 'qrcode.react';

interface ShareRoundModalProps {
    open: boolean;
    roundId: string;
    onClose: () => void;
}

const ShareRoundModal = ({ open, roundId, onClose }: ShareRoundModalProps) => {
    const shareUrl = `${window.location.origin}/join/${roundId}`;
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (open) setCopied(false);
    }, [open]);

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            // clipboard unavailable in this environment
            console.error("clipboard unavailable: " + error);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <ModalDialog>
                <ModalClose />
                <Typography level="h4">Share Round</Typography>
                <Stack spacing={2} alignItems="center">
                    <QRCodeSVG value={shareUrl} size={200} />
                    <Typography level="body-sm" sx={{ wordBreak: 'break-all', textAlign: 'center' }}>
                        {shareUrl}
                    </Typography>
                    <Button
                        variant="solid"
                        color={copied ? 'success' : 'primary'}
                        onClick={handleCopyLink}
                        fullWidth
                    >
                        {copied ? 'Copied!' : 'Copy Link'}
                    </Button>
                </Stack>
            </ModalDialog>
        </Modal>
    );
};

export default ShareRoundModal;
